type IntentStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;
export type StudioProductionMode = "clips" | "segments";
/** One reservation per (actor, recording, mode): clips and segments must never share a request id. */
const storageKey = (actorId: string, sourceId: string, mode: StudioProductionMode) =>
  `studio-production:${actorId}:${sourceId}:${mode}`;

export const getStudioProductionRequestId = (
  storage: IntentStorage,
  actorId: string,
  sourceId: string,
  mode: StudioProductionMode = "clips",
): string => {
  const key = storageKey(actorId, sourceId, mode);
  const existing = storage.getItem(key);
  if (existing) return existing;
  const requestId = crypto.randomUUID();
  // If persistence fails, fail before HTTP dispatch so a reload cannot lose the key.
  storage.setItem(key, requestId);
  return requestId;
};

export const acknowledgeStudioProduction = (
  storage: IntentStorage,
  actorId: string,
  sourceId: string,
  requestId: string,
  mode: StudioProductionMode = "clips",
): void => {
  const key = storageKey(actorId, sourceId, mode);
  if (storage.getItem(key) === requestId) storage.removeItem(key);
};
